import { useState } from "react";
import { useSearchParams } from "@usas/ui-web/wrappers/ReactRouterDom";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

import useAccountMFAData from "@usas/ui-web/state/account/accountMFA/UseAccountMFAData";

const INITIAL_LOGIN_ERROR_POPUP_STATE = {
  displayPopup: false,
  errorMessage: ''
};

//TODO delete?
const useAccountCreationMFA = () => {
  const [searchParams,] = useSearchParams();
  const { accountCreationState, resetAccountCreationState } = useAccountCreationData();
  const { accountMFAState, postAccountSetMFA, resetAccountMFAState } = useAccountMFAData();
  const [loginErrorPopupState, setLoginErrorPopupState] = useState(INITIAL_LOGIN_ERROR_POPUP_STATE);

  const onCancelClicked = () => {
    resetAccountCreationState(); // clears state and sends back to login
  };

  const onCloseLoginErrorPopupClicked = () => {
    resetAccountMFAState();
    setLoginErrorPopupState(INITIAL_LOGIN_ERROR_POPUP_STATE);
  };

  const onSubmitFormCallback = (formState) => {
    const accessToken = accountCreationState.loginData?.accessToken;
    const email = formState.useEmail === true;
    const textMessage = formState.useTextMessage === true;
    const phoneNumber = formState.useTextMessage === true ? formState.phoneNumber : '';
    
    const postAccountSetMFAPromise = postAccountSetMFA(accessToken, email, textMessage, phoneNumber);

    if (postAccountSetMFAPromise ?? false) {
      postAccountSetMFAPromise.then((newState) => {
        if (newState ?? false) {
          // Successful login
          if (searchParams.get('retUrl')) {
            window.location.href = `${searchParams.get('retUrl')}?token=${accessToken}`;
          } else if (window.location.href.indexOf('?') === -1) {
            window.location.href = `${window.location.href}?token=${accessToken}`;
          } else {
            window.location.href = `${window.location.href}&token=${accessToken}`;
          }
        }
      }).catch((e) => {
        setLoginErrorPopupState({
          ...loginErrorPopupState,
          displayPopup: true,
          errorMessage: e?.message
        });
      });
    }
  };

  return {
    isLoading: accountMFAState.isObjLoading,
    device: accountCreationState.loginData?.emailAddress || '',
    loginErrorPopupState,
    onSubmitFormCallback,
    onCancelClicked,
    onCloseLoginErrorPopupClicked
  };
};

export default useAccountCreationMFA;